/**
 * sc-card-price.js — wrap "From " prefix trên card prices vào <span class="sc-price-from">.
 * Locale trả về "From $X.XX" trong cùng một span → không style riêng được nếu không wrap.
 * Chỉ áp dụng cho card scope (.card__information, .card__content) — tránh PDP.
 */
(function () {
  var SEL =
    '.card__information .price-item--sale:not([data-sc-from]),' +
    '.card__content .price-item--sale:not([data-sc-from])';
  var RE = /^(\s*[Ff]rom\s+)(.+)$/;

  function wrap(el) {
    var raw = (el.textContent || '').trim();
    var m = raw.match(RE);
    if (!m) return;
    el.setAttribute('data-sc-from', '1');
    el.innerHTML =
      '<span class="sc-price-from">' + m[1].trim() + '</span> ' +
      '<span class="sc-price-amount">' + m[2] + '</span>';
  }

  function scan(root) {
    if (!root) return;
    if (root === document) {
      root.querySelectorAll(SEL).forEach(wrap);
      return;
    }
    if (root.nodeType !== 1) {
      scan(root.parentElement);
      return;
    }
    if (root.matches(SEL)) wrap(root);
    root.querySelectorAll(SEL).forEach(wrap);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(document); });
  } else {
    scan(document);
  }

  // Chỉ scan subtree mới (AJAX filters/infinite scroll), không scan lại toàn document.
  var scheduled = false;
  var pendingRoots = new Set();
  var mo = new MutationObserver(function (records) {
    records.forEach(function (record) {
      record.addedNodes.forEach(function (node) {
        pendingRoots.add(node.nodeType === 1 ? node : node.parentElement);
      });
    });
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      pendingRoots.forEach(scan);
      pendingRoots.clear();
    });
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
